export const apiUrl = 'https://strapi.ecofoodmap.be';
